"use client"

import React from "react"

import { Button } from "@/shadcn/components/ui/button"
import { Card } from "@/shadcn/components/ui/card"
import { cn } from "@/lib/utils"

import DeleteAccountCard from "./account/DeleteAccountCard"
import EmailCard from "./account/EmailCard"
import PageHeading from "./account/PageHeading"
import PasswordCard from "./account/PasswordCard"
import ProfileCard from "./account/ProfileCard"
import {
  CARD,
  CARD_DESCRIPTION,
  CARD_TITLE,
  SM_BUTTON,
} from "./account/styles"

export default function ClientAccountPage(props: any) {
  const isFieldInvalid = (field: string): Boolean => {
    if (props.errors) {
      if (props.errors && props.errors.length) {
        for (let i = 0; i < props.errors.length; ++i) {
          if (props.errors[i].errors?.validation?.[field]) {
            return true;
          }
        }
      }
    }
    return false;
  };

  return (
    <div className="tw:mx-auto tw:flex tw:w-full tw:max-w-[968px] tw:flex-col tw:gap-4 tw:p-4 tw:font-sans tw:md:p-6">
      <PageHeading
        title="Your Account"
        description="Manage dlvr.it account settings."
      />

      <ProfileCard {...props} appName={props.app.appName} />

      <EmailCard
        email={props.user.detail.email}
        isEditing={props.isEditing.email}
        onEdit={() => {
          props.onBeginEdit('email');
        }}
        onChange={props.onUpdateField}
        onSave={() => {
          props.updateUser();
        }}
        onCancel={() => {
          props.onCancelEdit('email');
        }}
        onVerify={() => {
          props.resendEmailConfirmation();
        }}
        app={props.app}
        emailActive={props.user.detail.emailActive}
        bounceCount={props.user.detail.bounceCount}
        isFieldInvalid={isFieldInvalid}
      />

      <PasswordCard
        editing={props.isEditing.password}
        onStartEdit={() => {
          props.onBeginEdit('password');
        }}
        onSave={() => {
          props.updatePassword();
        }}
        onCancel={() => {
          props.onCancelEdit('password');
        }}
        app={props.app}
        updatePasswordValue={props.updatePasswordValue}
        isFieldInvalid={isFieldInvalid}
      />

      <AccountManagerCard
        managerName={props.user?.detail?.clientInfo?.organization}
        onDisconnect={props.convertClient}
      />

      <DeleteAccountCard
        onDelete={() => {
          props.deleteAccount();
        }}
      />
    </div>
  )
}

function AccountManagerCard({
  managerName,
  onDisconnect,
}: {
  managerName: string
  onDisconnect: () => void
}) {
  return (
    <Card className={CARD}>
      {/* Stacks on a phone. `flex-1` is `flex: 1 1 0%`, so with a `shrink-0`
          button beside it the text column had no width it was unwilling to
          give up: at 375px the button kept its ~150px and the text got ~120,
          breaking the title over two lines and the description over eight, in
          a column narrower than the button. `flex-wrap` alone cannot fix that
          - a row only wraps when an item cannot fit its BASIS - so the text
          block gets `basis-full` below `sm` and `sm:basis-0` from there. */}
      <div className="tw:flex tw:w-full tw:flex-wrap tw:items-center tw:gap-x-2 tw:gap-y-4 tw:p-4 tw:sm:gap-y-2">
        <div className="tw:flex tw:min-w-0 tw:shrink tw:grow tw:basis-full tw:flex-col tw:gap-1 tw:sm:basis-0">
          <p className={CARD_TITLE}>Account Manager</p>
          <p className={CARD_DESCRIPTION}>
            Your social media profiles are being managed by {managerName}
          </p>
        </div>
        <Button
          type="button"
          variant="secondary"
          size="sm"
          className={cn(SM_BUTTON, "tw:shrink-0")}
          onClick={onDisconnect}
        >
          Disconnect from {managerName}
        </Button>
      </div>
    </Card>
  )
}
